import { ClosePopup, Dialog, Loading, Notify, Quasar, Ripple, } from 'quasar';
import 'quasar/dist/quasar.ie.polyfills';
export async function loadQuasarLanguageAsync(lang) {
    if (lang === 'en')
        lang = 'en-us';
    await import(`quasar/lang/${lang}`)
        .then((dictionary) => {
        Quasar.lang.set(dictionary.default);
    });
}
// leave the export, even if you don't use it
export default ({ Vue }) => {
    Vue.use(Quasar, {
        config: {
            brand: {},
            notify: { position: 'top', timeout: 1300, color: 'secondary' },
        },
        components: {},
        directives: { Ripple, ClosePopup },
        plugins: {
            Dialog,
            Loading,
            Notify,
        },
    });
};
